import React from "react";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import HowItWorks from "@/components/sections/HowItWorks";
import FAQ from "@/components/sections/FAQ";
import WhatsAppFloat from "@/components/sections/WhatsAppFloat";
import { Button } from "@/components/ui/button";
import { ClipboardList, SearchCheck, ListChecks, HandCoins, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLeadDialog } from "@/components/sections/LeadDialog";

const detail = [
  {
    icon: ClipboardList,
    title: "1. Solicitud",
    desc: "Completas un formulario en línea con tu información personal, el monto que necesitas y el plazo deseado. Este primer paso es totalmente gratuito y no genera ningún compromiso. La información mínima suele incluir tu nombre, RUT, teléfono y correo electrónico.",
  },
  {
    icon: SearchCheck,
    title: "2. Evaluación",
    desc: "Las entidades financieras aliadas de Bancoorp reciben tu solicitud y revisan tu perfil crediticio de forma independiente. Cada institución aplica su propia política de riesgo y puede consultar información en el Registro de Deudores, Dicom/Equifax y otras fuentes permitidas por ley.",
  },
  {
    icon: ListChecks,
    title: "3. Ofertas",
    desc: "Si tu perfil es aprobado por una o más entidades, recibirás propuestas claras indicando tasa, CAE (Carga Anual Equivalente), cuota mensual, plazo y costo total del crédito. Compara libremente entre las ofertas — Bancoorp no influye en las condiciones.",
  },
  {
    icon: HandCoins,
    title: "4. Elección y contratación",
    desc: "Tú eliges la oferta que más te convenga (o ninguna). La contratación y el desembolso del crédito se realizan directamente con la entidad financiera elegida, bajo su contrato y condiciones. Bancoorp nunca recibe tu dinero ni te cobra comisiones.",
  },
];

export default function ComoFunciona() {
  const { open } = useLeadDialog();
  const openWA = () => open("como-funciona");
  return (
    <div className="min-h-screen bg-white" data-testid="como-funciona-page">
      <Header onCtaClick={openWA} />
      <main>
        <section className="bg-gradient-to-b from-slate-50 to-white py-16 lg:py-24 border-b border-slate-200">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
              Cómo funciona
            </span>
            <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Un proceso claro y transparente
            </h1>
            <p className="mt-6 max-w-2xl text-lg text-slate-600 leading-relaxed">
              Bancoorp conecta a personas en Chile con entidades financieras que
              otorgan créditos de consumo y préstamos personales. Así funciona
              paso a paso, sin letra chica.
            </p>
          </div>
        </section>

        <HowItWorks />

        <section className="py-20 bg-slate-50 border-y border-slate-200">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
              Detalle de cada etapa
            </h2>
            <div className="mt-10 space-y-6">
              {detail.map((d, i) => (
                <article
                  key={i}
                  className="rounded-2xl bg-white border border-slate-200 p-6 sm:p-8 flex flex-col sm:flex-row gap-5"
                  data-testid={`detail-step-${i}`}
                >
                  <div className="h-12 w-12 rounded-xl bg-blue-600 text-white flex items-center justify-center shrink-0">
                    <d.icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">
                      {d.title}
                    </h3>
                    <p className="mt-2 text-slate-600 leading-relaxed">
                      {d.desc}
                    </p>
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-10 rounded-2xl bg-slate-900 text-white p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
              <div>
                <h3 className="text-xl font-bold">¿Listo para empezar?</h3>
                <p className="text-slate-300 mt-1">
                  Completa tu evaluación en menos de 3 minutos.
                </p>
              </div>
              <Link to="/evaluacion">
                <Button className="bg-teal-400 hover:bg-teal-300 text-slate-900 font-semibold rounded-full px-6 py-5">
                  Solicitar evaluación
                  <ArrowRight className="h-4 w-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        <FAQ />
      </main>
      <Footer onCtaClick={openWA} />
      <WhatsAppFloat />
    </div>
  );
}
